module.exports = __webpack_public_path__ + "img/arrow_black@2x.80d661da.png";